<template>
  <div class="db">
    <Error v-if="error" :error="error"/>
    <Loading v-if="loading"/>

    <div class="sidebar" :class="{ hidden:($route.query.hide==='true') }">
      <Folder v-for="(info, uuid) in dblist"
        :key="uuid"
        :uuid="uuid"
        :name="info.name"
        :files="info.files"
        :vfilter="false"/>
    </div>
    <router-view/>
  </div>
</template>

<script>
import Error from '@/components/Error';
import Loading from '@/components/Loading';

import Folder from '@/components/System/Folder';

export default {
  name: 'DB',
  data() {
    return {
      error: null,
      loading: null,
      dblist: null,
    };
  },
  computed: {
    // the datasheets carry no release version: it exists only if state.json collected it over several game versions
    hasHistory() {
      const seen = {};
      Object.values(this.dblist || {}).forEach(f => Object.values(f.files || {}).forEach(x => { seen[x.version] = 1; }));
      return Object.keys(seen).length > 1;
    }
  },
  components: {
    Error,
    Loading,
    Folder,
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.error = this.dblist = null;
      this.loading = true;
      fetch("./data/dblist.json").then(res => {
        this.loading = false;
        if (res.ok) res.json().then(data=>{
          this.dblist = data;
        }); else {
          this.error = res.status+' '+res.statusText;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.db {
  display: flex;
  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
  }
  .sidebar {
    flex: none;
    box-sizing: border-box;
    width: 300px;
    height: 100%;
    font-size: 1.2em;
    overflow-x: hidden;
    overflow-y: scroll;
    display: inline-block;
    background: var(--panel);
    border-right: 1px solid var(--line-dim);
    @media screen and (max-width: 767px) {
      width: 100%;
    }
  }
}
</style>
